var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-full text-black px-3",class:_vm.textClass,domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }